import last from 'lodash/last';
import camelCase from 'lodash/camelCase';

export default (fileName) => {
    return camelCase(last(fileName.split('/')).replace(/(\.\/|\.js)/g, ''));
};
